import { render, staticRenderFns } from "./AdwordsStats.vue?vue&type=template&id=6bbfc2d2&scoped=true"
import script from "./AdwordsStats.vue?vue&type=script&lang=js"
export * from "./AdwordsStats.vue?vue&type=script&lang=js"
import style0 from "./AdwordsStats.vue?vue&type=style&index=0&id=6bbfc2d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbfc2d2",
  null
  
)

export default component.exports